<template>
  <div>
    <div
      :class="tipo === 'imagem' ? 'componente-lateral-holder' : 'componente-lateral-holder video'"
    >
      <!-- <img v-if="tipo === 'video'" src="require(@/assets/imgs/pauta.jpg)"> -->
      <span v-if="tipo === 'imagem'"><strong>Edição:</strong> 11/06/2019</span>
      <a v-if="tipo === 'imagem'" :href="link" target="_blank">
        <img src="@/assets/imgs/pauta.jpg" />
      </a>
      <iframe
        v-if="tipo === 'video'"
        class="video"
        :src="link"
        color="#660099"
        gesture="media"
        allow="encrypted-media; accelerometer; gyroscope; picture-in-picture"
        allowfullscreen
        autoplay="false"
      ></iframe>
    </div>
    <!-- <span v-if="tipo === 'imagem'"><strong>Edição:</strong> 21/05/2019</span> -->
  </div>
</template>

<script>
export default {
  name: 'VideoLateral',
  props: {
    link: String,
    tipo: {
      type: String,
      default: 'video',
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.componente-lateral-holder {
  position: relative;
  display: flex;
  background: #000;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  // border: 5px solid black;
  width: 300px;
  height: 185px;
  margin: 0 auto;
  margin-bottom: 5px;
  overflow: hidden;
  -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);

  span {
    position: absolute;
    top: 5px;
    right: 5px;
    font-family: 'OpenSans';
    font-size: 11px;
    text-transform: uppercase;
    color: white;
    background: $cor_rosa_dark;
    padding: 2px 10px;
    border-radius: 30px;
  }

  iframe {
    width: 300px;
    height: 185px;
    border: 0px;

    & .ytp-title-channel-logo {
      display: none;
    }
  }
}

.video {
  -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
}

@media all and (min-width: 300px) and (max-width: 679px) {
  .componente-lateral-holder {
    display: flex;
    align-items: center;
    justify-items: center;
    max-width: calc(100vw - 50px);
    width: calc(100vw - 50px);
    height: 26vh;
    -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
    -moz-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);

    & img {
      max-width: calc(100vw - 50px);
      width: calc(100vw - 50px);
      object-fit: cover;
    }

    & iframe {
      width: calc(100vw - 50px);
      height: auto;
    }

    & span {
      top: 3px;
      right: 3px;
      font-size: 8px;
      padding: 1px 5px;
      border-radius: 20px;
    }
  }

  & .video {
    box-shadow: none !important;
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .componente-lateral-holder {
    -webkit-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
    -moz-box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.45);
  }
}
</style>
